<template>
  <div
    v-if="question.isSelect || question.isRadio || question.isCheckbox"
    :class="$style.itemContainer"
  >
    <div
      v-if="question.image"
      class="rounded-lg overflow-hidden bg-static-info-low mb-16"
      :class="{ 'bg-transparent justify-center': question.isSmileyImage }"
    >
      <RevIllustration
        alt=""
        class="object-contain"
        :class="{
          'h-[150px] w-[150px] mx-auto': question.isSmileyImage,
          [$style.image]: !question.isSmileyImage,
          'mx-auto': question.key === 'touch_screen',
        }"
        :height="395"
        loading="eager"
        :src="question.image"
        :width="372"
      />
    </div>
    <h3 class="heading-3" :class="question.showInfo ? 'mb-4' : 'mb-12'">
      {{ question.title }}
    </h3>

    <QuestionsFormItemText
      v-if="question.showInfo"
      class="mb-16"
      :info="question.info"
    />

    <RevInputSelect
      v-if="question.isSelect"
      :id="question.key"
      class="mt-8"
      :data-qa="question.key"
      :label="question.placeholder || ''"
      :model-value="typeof question.value === 'string' ? question.value : ''"
      :options="question.options"
      @update:model-value="
        (val) =>
          emit('answer', question.key, typeof val === 'string' ? val : '')
      "
    />

    <QuestionsFormRadioInput
      v-if="question.isRadio"
      :question
      :radio-model="Array.isArray(question.value) ? false : question.value"
      @answer="(key, value) => emit('answer', key, value)"
    />

    <QuestionsFormCheckbox
      v-if="question.isCheckbox"
      :checkbox-model="question.value"
      :question
      @answer="(key, value) => emit('answer', key, value)"
    />

    <div
      v-if="question.infoBlock"
      class="text-action-default-low body-2 my-8 flex flex-col gap-8"
    >
      <p v-for="text in question.infoBlock.paragraphs" :key="text">
        {{ text }}
      </p>
    </div>
  </div>
  <QuestionsFormConfirmation
    v-else-if="question.isConfirmation"
    :question
    @answer="(key, value) => emit('answer', key, value)"
  />
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'
import { RevInputSelect } from '@ds/components/InputSelect'

import type { RenderQuestion } from '~/scopes/buyback/composables/useFunnelQuestions'

import QuestionsFormCheckbox from './QuestionsFormCheckbox.vue'
import QuestionsFormConfirmation from './QuestionsFormConfirmation.vue'
import QuestionsFormItemText from './QuestionsFormItemText.vue'
import QuestionsFormRadioInput from './QuestionsFormRadioInput.vue'

defineProps<{
  question: RenderQuestion
}>()

const emit = defineEmits<{
  (event: 'answer', key: string, value: string | string[] | false): void
}>()
</script>

<style module>
.itemContainer {
  container-type: inline-size;
  container-name: item-container;
}
.image {
  width: 100%;
}
@container item-container (width > 450px) {
  .image {
    height: 372px;
    width: auto;
    margin-left: auto;
  }
}
</style>
